import { ROUTES } from '#/config/routes';

/** 生產製造 hub 導覽卡（不含加工廠占位）。 */
const productionNavigate = [
  {
    to: ROUTES.bom,
    title: 'BOM列表',
    subtitle: 'BOM 主檔列表與維護',
  },
  {
    to: ROUTES.workOrder,
    title: '製造命令',
    subtitle: '工單列表與建立',
  },
  {
    to: ROUTES.analysis,
    title: '分析',
    subtitle: '工單狀態與物料缺口',
  },
];

export default productionNavigate;

